import { generateAppsFlyerLink } from "lib/common"
import { useEffect } from "react"
import { sendAmplitudeEvent } from "lib/amplitude"
import { trackMetaEvent } from "lib/meta"
import { trackSnapchatClick } from "lib/snapchat"
import { sendGoogleClickConversion } from "lib/google"
import { twMerge } from "tailwind-merge"
import { useParams } from "react-router-dom"

type ImageKeys = "title" | "rating" | "preview" | "reviews"

type ImageLocalization = {
  en: string
} & Record<string, string>

type Images = {
  [K in ImageKeys]: ImageLocalization
}

type StorePageProps = {
  surveyId: string
  images: Images
}

export function StorePageImagesOnly(props: StorePageProps) {
  const { locale = "en" } = useParams()
  const { images } = props
  const titleImg = images.title[locale] || images.title.en
  const imgRating = images.rating[locale] || images.rating.en
  const imgPreview = images.preview[locale] || images.preview.en
  const imgReviews = images.reviews[locale] || images.reviews.en

  const onButtonClick = () => {
    trackMetaEvent("Lead")
    trackSnapchatClick()
    sendGoogleClickConversion(() =>
      sendAmplitudeEvent(
        "onboarding_cta_clicked",
        {
          onboarding: props.surveyId,
        },
        () => {
          location.assign(generateAppsFlyerLink(props.surveyId))
        },
      ),
    )
  }

  useEffect(() => {
    sendAmplitudeEvent("onboarding_started", {
      onboarding: props.surveyId,
    })
  }, [])

  return (
    <div className="max-w-[450px] mx-auto pt-[72px] px-6 pb-2">
      <a onClick={onButtonClick} className={twMerge("cursor-pointer")}>
        <img src={titleImg} />
      </a>
      <img src={imgRating} />
      <img src={imgPreview} />
      <img src={imgReviews} />
    </div>
  )
}
